import _ from 'lodash'

const calculateFeatFromAdvancedStats = (participants, action) => {
  const p = _.cloneDeep(participants)

  const sorted = p.sort((a, b) => {
    if (a.stats.advanced.for[action] < b.stats.advanced.for[action] || _.isNil(a.stats.advanced.for[action])) return 1
    if (a.stats.advanced.for[action] > b.stats.advanced.for[action] || _.isNil(b.stats.advanced.for[action])) return -1
    return 0
  })

  if (sorted[0].stats.advanced.for[action] > 0) {
    const filtered = sorted.filter(f => f.stats.advanced.for[action] === sorted[0].stats.advanced.for[action])

    if (filtered.length > 1) {
      return filtered.map(f => {
        return {
          id: f.id || f.uuid,
          name: `${f.first_name} ${f.last_name}`,
          value: f.stats.advanced.for[action]
        }
      })
    }

    return [{
      id: sorted[0].id || sorted[0].uuid,
      name: `${sorted[0].first_name} ${sorted[0].last_name}`,
      value: sorted[0].stats.advanced.for[action]
    }]
  }

  return null
}

const calculateFeatFromStat = (participants, stat) => {
  const p = _.cloneDeep(participants)

  const sorted = p.sort((a, b) => {
    if (a.stats[stat] < b.stats[stat] || _.isNil(a.stats[stat])) return 1
    if (a.stats[stat] > b.stats[stat] || _.isNil(b.stats[stat])) return -1
    return 0
  })

  if (sorted[0].stats[stat] > 0) {
    const filtered = sorted.filter(f => f.stats[stat] === sorted[0].stats[stat])

    if (filtered.length > 1) {
      return filtered.map(f => {
        return {
          id: f.id || f.uuid,
          name: `${f.first_name} ${f.last_name}`,
          value: f.stats[stat]
        }
      })
    }

    return [{
      id: sorted[0].id || sorted[0].uuid,
      name: `${sorted[0].first_name} ${sorted[0].last_name}`,
      value: sorted[0].stats[stat]
    }]
  }

  return null
}

const calculateFeats = (participants) => {
  const featAwards = []

  featAwards.push(Object.assign({ title: 'Cleaning House', description: 'Most clean hits' }, { winners: calculateFeatFromAdvancedStats(participants, 'C') }))
  featAwards.push(Object.assign({ title: 'Headhunter', description: 'Most assaults' }, { winners: calculateFeatFromAdvancedStats(participants, 'A') }))
  featAwards.push(Object.assign({ title: 'Defensive Expert', description: 'Most returns' }, { winners: calculateFeatFromAdvancedStats(participants, 'R') }))
  featAwards.push(Object.assign({ title: 'Quick-hand', description: 'Most intercepts' }, { winners: calculateFeatFromAdvancedStats(participants, 'N') }))
  featAwards.push(Object.assign({ title: 'Give Them A Hand', description: 'Most disarms' }, { winners: calculateFeatFromAdvancedStats(participants, 'D') }))
  featAwards.push(Object.assign({ title: 'Size Matters Not', description: 'Most priority overrides' }, { winners: calculateFeatFromAdvancedStats(participants, 'V') }))
  featAwards.push(Object.assign({ title: 'Tis But A Scratch', description: 'Most indirect hits' }, { winners: calculateFeatFromAdvancedStats(participants, 'I') }))
  featAwards.push(Object.assign({ title: 'Paragon', description: 'Most honor' }, { winners: calculateFeatFromStat(participants, 'honor') }))
  featAwards.push(Object.assign({ title: 'Flawless', description: 'Most wins by shutout' }, { winners: calculateFeatFromStat(participants, 'flawless') }))

  return featAwards.filter(f => !_.isNil(f.winners))
}

export default calculateFeats
